import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import img1 from '../../../Assets/crane/img1.png'
import icon1 from '../../../Assets/crane/icon1.svg'
import icon2 from '../../../Assets/crane/icon2.svg'
import icon3 from '../../../Assets/crane/icon3.svg'
import icon4 from '../../../Assets/crane/icon4.svg'
import icon5 from '../../../Assets/crane/icon5.svg'
import dropdown from '../../../Assets/crane/dropdown.png'
import dropup from '../../../Assets/crane/dropUp.png'


function CraneSideBar() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isTrackingExpanded, setIsTrackingExpanded] = useState(false);
    const [expandedSection, setExpandedSection] = useState(null);

    const handleSectionClick = (sectionKey, path) => {
        // toggle expand/collapse
        setExpandedSection(prev => prev === sectionKey ? null : sectionKey);
        // navigate
        navigate(path);
    };
    return (
        <>
            <div className="md:max-w-[284px] max-w-[90%] md:ml-0 ml-auto md:mr-0 mr-auto w-full px-[19px] pb-[30px] bg-[#F9F9F9] border-[1px] border-[#E7E4FC] rounded-[12px]">
                <div className="flex justify-center">
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/img1.png' className='h-[150px] w-[150px]' alt="" />
                </div>
                <div className='flex flex-col gap-[20px]'>

                    <div className="flex flex-col gap-[11px]">
                        <div
                            onClick={() => setIsTrackingExpanded((prev) => !prev)}
                            className={`cursor-pointer flex items-center justify-between ${location?.pathname === "/crane-dashboard/tracking" ? 'side-bar-item-active' : "side-bar-item"}`}
                        >
                            <div className='flex items-center gap-[10px]' onClick={() => navigate("/crane-dashboard/tracking")}>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon1.svg' className='h-[20px] w-[20px]' alt="" />
                                <p className={`${location?.pathname === "/crane-dashboard/tracking" ? 'sidebar-text-active' : "sidebar-text"}`}>Status Tracking</p>
                            </div>
                            <span className="pr-[10px]">
                                <img src={isTrackingExpanded ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropUp.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropdown.png'} alt="" className='h[18px] w-[18px]' />
                            </span>
                        </div>
                        {isTrackingExpanded && (
                            <div className="flex flex-col gap-[11px] pl-[50px]">
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                            </div>)}

                    </div>

                    <div className="flex flex-col gap-[11px]">
                        <div
                            onClick={() => handleSectionClick("quotation", "/crane-dashboard/quotationupdate")}
                            className={`cursor-pointer flex items-center justify-between ${location?.pathname === "/crane-dashboard/quotationupdate" ? 'side-bar-item-active' : "side-bar-item"}`}
                        >
                            <div className='flex items-center gap-[10px]'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon2.svg' className='h-[20px] w-[20px]' alt="" />
                                <p className={`${location?.pathname === "/crane-dashboard/quotationupdate" ? 'sidebar-text-active' : "sidebar-text"}`}>Quotation & Updates</p>
                            </div>
                            <span className="pr-[10px]">
                                <img src={expandedSection === "quotation" ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropUp.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropdown.png'} alt="" className='h[18px] w-[18px]' />
                            </span>
                        </div>

                        {expandedSection === "quotation" && (
                            <div className="flex flex-col gap-[11px] pl-[50px]">
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[11px]">
                        <div
                            onClick={() => handleSectionClick("history", "/crane-dashboard/history")}
                            className={`cursor-pointer flex items-center justify-between ${location?.pathname === "/crane-dashboard/history" ? 'side-bar-item-active' : "side-bar-item"}`}
                        >
                            <div className='flex items-center gap-[10px]'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon3.svg' className='h-[20px] w-[20px]' alt="" />
                                <p className={`${location?.pathname === "/crane-dashboard/history" ? 'sidebar-text-active' : "sidebar-text"}`}>History & Receipts</p>
                            </div>
                            <span className="pr-[10px]">
                                <img src={expandedSection === "history" ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropUp.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropdown.png'} alt="" className='h[18px] w-[18px]' />
                            </span>
                        </div>

                        {expandedSection === "history" && (
                            <div className="flex flex-col gap-[11px] pl-[50px]">
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[11px]">
                        <div
                            onClick={() => handleSectionClick("cancelled", "/crane-dashboard/cancelled")}
                            className={`cursor-pointer flex items-center justify-between ${location?.pathname === "/crane-dashboard/cancelled" ? 'side-bar-item-active' : "side-bar-item"}`}
                        >
                            <div className='flex items-center gap-[10px]'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon4.svg' className='h-[20px] w-[20px]' alt="" />
                                <p className={`${location?.pathname === "/crane-dashboard/cancelled" ? 'sidebar-text-active' : "sidebar-text"}`}>Cancelled Orders</p>
                            </div>
                            <span className="pr-[10px]">
                                <img src={expandedSection === "history" ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropUp.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropdown.png'} alt="" className='h[18px] w-[18px]' />
                            </span>
                        </div>

                        {expandedSection === "cancelled" && (
                            <div className="flex flex-col gap-[11px] pl-[50px]">
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[11px]">
                        <div
                            onClick={() => handleSectionClick("summary", "/crane-dashboard/summary")}
                            className={`cursor-pointer flex items-center justify-between ${location?.pathname === "/crane-dashboard/summary" ? 'side-bar-item-active' : "side-bar-item"}`}
                        >
                            <div className='flex items-center gap-[10px]'>
                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon5.svg' className='h-[20px] w-[20px]' alt="" />
                                <p className={`${location?.pathname === "/crane-dashboard/summary" ? 'sidebar-text-active' : "sidebar-text"}`}>Summary & Reviews</p>
                            </div>
                            <span className="pr-[10px]">
                                <img src={expandedSection === "summary" ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropUp.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/dropdown.png'} alt="" className='h[18px] w-[18px]' />
                            </span>
                        </div>

                        {expandedSection === "summary" && (
                            <div className="flex flex-col gap-[11px] pl-[50px]">
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                                <p className="m-0 sidebar-text">Track By Accident Number</p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    )
}

export default CraneSideBar